import { html } from '~/lib/bn-lit-element';
import { LitSirenEntityMixin } from '../../utility/lit-siren-entity-mixin';
import { LitEntityMixin } from '../../utility/lit-entity-mixin';
import { LevelColours } from '../../utility/level-colours-mixin';
import { BnMapMarker } from '../../common/bn-map-marker';

class BinMapMarker extends LitSirenEntityMixin(LitEntityMixin(BnMapMarker)) {
  render() {
    return html`
      ${super.render()}
      <lit-entity .href="${this.latestLevelHref}" @update="${this._onUpdateLevel}"></lit-entity>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.latestLevelHref = this.getHref('https://api.binsentry.com/rel/bin-level-latest');
    this._updateInfo();
  }

  _onUpdateLevel(e) {
    const { entity } = e.detail;
    this.latestLevelEntity = entity;
    const level = entity && entity.properties;
    if (!level) {
      this.icon = 'default';
      return;
    }
    // pick an icon based on the current bin level
    const totalVolume = this.getProperty('volumes').total;
    const volume = level.volume / totalVolume;
    this.icon = LevelColours.getThreshold(volume * 100).name;
  }
}

window.customElements.define('bin-map-marker', BinMapMarker);
